'use strict';

class ProyectoAdjudicadoController {
  constructor() {

  }


}

export default ProyectoAdjudicadoController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/proyecto-adjudicado/proyecto-adjudicado.controller.js